
<template>
    <div class="admin-view">
      <NavigationView />
      <div class="page">
        <div class="page-header">
          <div>
            <div class="page-title">ผู้ใช้งาน</div>
          </div>
        </div>

        <v-card class="data-card">
          <div class="data-card-toolbar">
            <span class="data-card-count">ทั้งหมด {{ items.length }} คน</span>
            <v-text-field
              v-model="search"
              class="search-field"
              prepend-inner-icon="mdi-magnify"
              placeholder="ค้นหาชื่อ อีเมล หรือฝ่าย"
              outlined
              dense
              rounded
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :loading="loading"
            loading-text="กำลังโหลด..."
            no-data-text="ยังไม่มีผู้ใช้งาน"
            no-results-text="ไม่พบผู้ใช้งานที่ค้นหา"
            :items-per-page="10"
            class="data-table"
            >
            <template slot="item.admin" slot-scope="{ item }">
                <v-chip
                  small
                  :color="item.admin === 1 ? 'secondary' : 'grey lighten-3'"
                  :text-color="item.admin === 1 ? 'primary' : 'grey darken-2'"
                  class="role-chip"
                >
                  {{ item.admin === 1 ? 'แอดมิน' : 'ผู้ใช้งาน' }}
                </v-chip>
            </template>
            <template slot="item.actions" slot-scope="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="edit(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>แก้ไข</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="remove(item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>ลบ</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </div>
      <v-dialog v-model="editdatadialog" max-width="700px" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title>
          <span class="headline dialog-title">แก้ไขผู้ใช้งาน</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <v-text-field
                    v-model="EditData.Name"
                    name="Name"
                    label="ชื่อ"
                    class="input-group--focused"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    v-model="EditData.Surname"
                    name="Surname"
                    label="นามสกุล"
                    class="input-group--focused"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    v-model="EditData.Email"
                    name="Email"
                    label="อีเมล"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    v-model="EditData.Department"
                    name="Department"
                    label="ฝ่าย"
                    class="input-group--focused"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex md12 xs12>
                  <v-switch
                    v-model="EditData.Admin"
                    color="primary"
                    inset
                    label="ผู้ดูแลระบบ (แอดมิน)"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
            <!-- <v-text-field label="Name" v-model="form.name"></v-text-field> -->
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">ยกเลิก</v-btn>
          <v-btn color="primary" depressed @click="updateItem">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deletedatadialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline dialog-title">ยืนยันการลบ</span>
        </v-card-title>
        <v-card-text>
          คุณต้องการลบผู้ใช้ "{{ DataToDelete && (DataToDelete.name + ' ' + DataToDelete.surname) }}" ใช่หรือไม่
          ผู้ใช้ที่ถูกลบจะ login เข้าระบบไม่ได้
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDeleteDialog">ยกเลิก</v-btn>
          <v-btn color="error" depressed @click="deleteItem()">ลบ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <!-- <search-panel :rightDrawer="rightDrawer" @cancelSearch="cancelSearch" @searchData="searchOrders">
        <v-layout row>
          <v-flex xs11 offset-xs1>
            <v-text-field name="reference" label="Reference" light v-model="searchFilter.contain.reference"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs11 offset-xs1>
            <v-text-field name="customer" label="Customer" light v-model="searchFilter.contain.customer"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs11 offset-xs1>
            <v-text-field name="minAmount"  type="number"  label="Min Amount" light v-model="searchFilter.greaterThanOrEqual.amount"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs11 offset-xs1>
            <v-text-field name="maxAmount"  type="number"  label="Max Amount" light v-model="searchFilter.lessThanOrEqual.amount"></v-text-field>
          </v-flex>
        </v-layout> 
      </search-panel> -->
      <!-- <confirm-dialog
        :dialog="dialog"
        :dialogTitle="dialogTitle"
        :dialogText="dialogText"
        @onConfirm="onConfirm"
        @onCancel="onCancel"
      ></confirm-dialog>
      <v-snackbar v-if="loading === false" :right="true" :timeout="2000" :color="mode" v-model="snackbar">
        {{ notice }}
        <v-btn dark text @click.native="closeSnackbar">Close</v-btn>
      </v-snackbar> -->
    <FooterView></FooterView>
    </div>
    
   
     
</template>
    
    
<script>
import axios from 'axios';

import { API_URL } from '@/config';
import NavigationView from '../../components/Navigation.vue'
import FooterView from '../../components/Footer.vue';
import Swal from 'sweetalert2';
// import Table from '../../components/Table.vue';

//   import TableHeaderButtons from '../../components/TableHeaderButtons.vue'
//   import SearchPanel from '../../components/SearchPanel.vue';
//   import ConfirmDialog from '../../components/ConfirmDialog.vue';
export default {
    name: 'ListUserView',
    components: {
    // Table,
    NavigationView,
    FooterView

    //   ConfirmDialog,
    //   SearchPanel

    },
    data() {
      return {
        headers: [
            { text: 'ชื่อ', value: 'name' },
            { text: 'นามสกุล', value: 'surname' },
            { text: 'อีเมล', value: 'email' },
            { text: 'ฝ่าย', value: 'department' },
            { text: 'สิทธิ์', value: 'admin', filterable: false },
            { text: 'จัดการ', value: 'actions', sortable: false, filterable: false, align: 'end' }
        ],
        search: '',
        items: [],
        loading: true,
        pagination: {
            page: 1,
            rowsPerPage: 10,
        },
        editdatadialog: false,
        deletedatadialog: false,
        EditData: {
          id: null,
          Name: '',
          Surname: '',
          Email: '',
          Department: '',
          Admin: ''
        },
        DataToDelete: null
      };
    },
    mounted() {
    this.fetchData(); 
    },
    methods: {
    async fetchData() {
        try {
        const response = await axios.get(`${API_URL}/getuser`); 
        
        this.items = response.data.result; 
        this.loading = false;
        } catch (error) {
        console.error("Error fetching data:", error);
        this.loading = false;
        }
    },
    add() {
        this.$router.push('CreateUser');
    },
    edit(item) {
      this.EditData.id = item.id;
      this.EditData.Name = item.name;
      this.EditData.Surname = item.surname;
      this.EditData.Email = item.email;
      this.EditData.Department = item.department;
      this.EditData.Admin = item.admin === 1;
      this.editdatadialog = true;
    },
    closeDialog() {
      this.editdatadialog = false; 
    },
    updateItem() {
      axios.put(`${API_URL}/edituser/${this.EditData.id}`, this.EditData)
        .then(response => {
          if (response.data.responsecode == 200){
            Swal.fire({
              type: "success",
              title: "แก้ไขข้อมูลสำเร็จ",
              icon: "success",
              confirmButtonText: '<span style="padding: 15px" >ปิด</span>',
            });
          }
          else {
            Swal.fire({
              title: "แก้ไขข้อมูลไม่สำเร็จ",
              icon: "warning",
              confirmButtonText: '<span style="padding: 15px" >ปิด</span>',
            });

          }
          this.closeDialog(); 
          this.fetchData();
        })
        .catch(error => {
          console.error('Error updating item:', error);
        });
    },
    remove(item) {
      this.DataToDelete = item;
      this.deletedatadialog = true; 
    },
    closeDeleteDialog() {
      this.deletedatadialog = false; 
    },
    deleteItem() {
      
      axios.put(`${API_URL}/deleteuser/${this.DataToDelete.id}`, this.DataToDelete)
        .then(response => {
          if (response.data.responsecode == 200){
            Swal.fire({
              type: "success",
              title: "ลบข้อมูลสำเร็จ",
              icon: "success",
              confirmButtonText: '<span style="padding: 15px" >ปิด</span>',
            });
          }
          else {
            Swal.fire({
              title: "ลบข้อมูลไม่สำเร็จ",
              icon: "warning",
              confirmButtonText: '<span style="padding: 15px" >ปิด</span>',
            });

          }
          this.closeDeleteDialog(); 
          this.fetchData();
        })
        .catch(error => {
          console.error('Error updating item:', error);
        });
    },
  },
}
</script>

<style scoped>
.v-navigation-drawer {
    width: 200px;
}

.v-card-title {
    background-color: #4CAF50;
    color: white;
}

.v-card-subtitle {
    margin-bottom: 20px;
}

.v-dialog .v-text-field {
    margin-bottom: 20px;
}

.role-chip {
    font-weight: 600;
}
</style>
    